export default "__VITE_ASSET__BIJLRrGy__"